<template>
  <v-layout justify-center>
    <v-flex sm12 xs12>
      <v-card>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex key="card.title" md4 sm4 xs4>
              <v-card>
                <v-flex>
                  <v-text-field :readonly="true" :value="basicInfo.mblNo" label="MBLNO"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field :readonly="true" :value="basicInfo.hblNo" label="HBLNO"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field :readonly="true" :value="basicInfo.transportModeCode" label="運送形態"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field :readonly="true" :value="basicInfo.stackTypeCode" label="積み方"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field :readonly="true" :value="basicInfo.eta" label="ETA"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    :readonly="true"
                    :value="basicInfo.freightConfirmDate"
                    label="フレイト計算日"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field :readonly="true" :value="basicInfo.doNo" label="DONo"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field :readonly="true" :value="basicInfo.lastAgreeDate" label="諸掛承認日"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    :readonly="true"
                    :value="basicInfo.freights.map(i=>i.currencyCode+' '+i.price).join(' / ')"
                    label="海上航空運賃"
                  ></v-text-field>
                </v-flex>
                <v-layout row style="overflow-x: auto; margin:0px 10px" wrap>
                  <table
                    border="1"
                    class="table"
                    style="border-collapse:collapse;border-spacing:0;margin-bottom:20px;"
                  >
                    <tr>
                      <td>枝番</td>
                      <td>DO確定日</td>
                      <td>海上航空按分運賃</td>
                      <td>諸掛按分費用</td>
                      <td>
                        SJLCommission
                        <Br/>按分費用
                      </td>
                    </tr>
                    <tr
                      :class="colorClasses[branch.archiveYearMonth]"
                      :key="key"
                      v-for="(branch,key) in basicInfo.branches"
                    >
                      <td>
                        <router-link
                          :to="{name: 'B0802',query:{id: branch.id}}"
                          target="_blank"
                        >枝番{{ branch.branchCode }}</router-link>
                      </td>
                      <td>{{branch.confirmDate}}</td>
                      <td>{{branch.costs.filter(i=>i.freight).map(i=>i.currencyCode+' '+i.price).join(' / ')}}</td>
                      <td>{{branch.costs.filter(i=>i.local).map(i=>i.currencyCode+' '+i.price).join(' / ')}}</td>
                      <td>{{branch.costs.filter(i=>i.sjlCommission).map(i=>i.currencyCode+' '+i.price).join(' / ')}}</td>
                    </tr>
                  </table>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex key="card.title1" md8 ms8 xs8>
              <v-card style="padding-bottom:150px;overflow-x:auto;overflow-y:hidden">
                <v-layout>
                  <v-flex :key="key" md6 sm6 v-for="(result,key) in basicInfo.yearMonths" xs12>
                    <time-line
                      :bgColor="colorClasses[result.yearMonth.replace('/','')]"
                      :result="result"
                    ></time-line>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
  <!-- <v-layout wrap>
    <v-flex md4 sm4 xs12>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :readonly="true" :value="basicInfo.mblNo" label="MBLNO"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :readonly="true" :value="basicInfo.hblNo" label="HBLNO"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :readonly="true" :value="basicInfo.transportModeCode" label="運送形態"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :readonly="true" :value="basicInfo.stackTypeCode" label="積み方"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :readonly="true" :value="basicInfo.eta" label="ETA"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :readonly="true" :value="basicInfo.freightConfirmDate" label="フレイト計算日"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :readonly="true" :value="basicInfo.doNo" label="DONo"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field :readonly="true" :value="basicInfo.lastAgreeDate" label="諸掛承認日"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12 sm6 xs12>
          <v-text-field
            :readonly="true"
            :value="basicInfo.freights.map(i=>i.currencyCode+' '+i.price).join(' / ')"
            label="海上航空運賃"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <table border="1" class="table" style="border-collapse:collapse;border-spacing:0;">
          <tr>
            <td>枝番</td>
            <td>DO確定日</td>
            <td>海上航空按分運賃</td>
            <td>諸掛按分費用</td>
            <td>
              SJLCommission
              <Br/>按分費用
            </td>
          </tr>
          <tr
            :class="colorClasses[branch.archiveYearMonth]"
            :key="key"
            v-for="(branch,key) in basicInfo.branches"
          >
            <td>
              <router-link :to="{name: 'B0802',query:{id: branch.id}}">枝番{{ branch.branchCode }}</router-link>
            </td>
            <td>{{branch.confirmDate}}</td>
            <td>{{branch.costs.filter(i=>i.freight).map(i=>i.currencyCode+' '+i.price).join(' / ')}}</td>
            <td>{{branch.costs.filter(i=>i.local).map(i=>i.currencyCode+' '+i.price).join(' / ')}}</td>
            <td>{{branch.costs.filter(i=>i.sjlCommission).map(i=>i.currencyCode+' '+i.price).join(' / ')}}</td>
          </tr>
        </table>
      </v-layout>
    </v-flex>
    <v-flex class="timelineA" md8 sm8 xs12>
      <div class>
        <v-layout>
          <v-flex :key="key" md4 sm6 v-for="(result,key) in basicInfo.yearMonths" xs12>
            <time-line :bgColor="colorClasses[result.yearMonth.replace('/','')]" :result="result"></time-line>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>-->
</template>
<script>
import TimeLine from '@/components/TimeLine'
export default {
  components: { TimeLine },
  data() {
    return {
      basicInfo: {
        freights: []
      },
      colors: ['bgRed', 'bgBlue', 'bgGreen', 'bgPurple', 'bgOrange'],
      colorClasses: {
        '2019/03': 'bgRed',
        '2019/04': 'bgBlue',
        '2019/05': 'bgGreen'
      }
    }
  },
  methods: {
    load(doNo) {
      this.$http
        .get(`/arap/finance/${doNo}/bl-information`)
        .then(res => {
          this.basicInfo = res.data
          let yearMonths = this.basicInfo.yearMonths
            .map(i => i.yearMonth)
            .sort((a, b) => a.localeCompare(b))
          for (let i = 0; i < yearMonths.length; i++) {
            this.colorClasses[yearMonths[i].replace('/', '')] = this.colors[
              i % this.colors.length
            ]
          }
        })
        .catch(() => {
          this.basicInfo = {}
        })
    }
  }
}
</script>
<style scoped>
.basicInfo {
  width: 25%;
  overflow: auto;
  display: inline-block;
  flex-direction: column;
  /* border: 1px red solid; */
}

.timelineA {
  overflow-x: auto;
  display: inline-block;
  border: 1px red solid;
}

table td {
  padding: 3px;
}

.outerBlock {
  /* border: 1px solid red; */
  display: flex;
  height: 100%;
}
</style>
